module.exports = __webpack_public_path__ + "01@2x.png?4027e4e80223b243f9b5347c1d8a5892";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/01@2x.png
// module id = 78
// module chunks = 0